export const blockPlace = async (placeId, isBlocked, authHeaderValue) => {
  try {
    const action = isBlocked ? "unblock" : "block";
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URI}/v1/admin/places/${placeId}/${action}`,
      {
        method: "POST",
        headers: {
          Authorization: authHeaderValue,
          "Content-Type": "application/json",
        },
      },
    );
    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }
  } catch (error) {
    console.log(error);
    throw new Error("Couldn't block/unblock place");
  }
};

export const blockReview = async (reviewId, isBlocked, authHeaderValue) => {
  try {
    const action = isBlocked ? "unblock" : "block";
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URI}/v1/admin/reviews/${reviewId}/${action}`,
      {
        method: "POST",
        headers: {
          Authorization: authHeaderValue,
        },
      },
    );
    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }
  } catch (error) {
    console.log(error);
    throw new Error("Couldn't block/unblock review");
  }
};

export const updatePlace = async (placeId, placeRequest, authHeaderValue) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URI}/v1/places/${placeId}`,
      {
        method: "PATCH",
        body: JSON.stringify(placeRequest),
        headers: {
          Authorization: authHeaderValue,
          "Content-Type": "application/json",
        },
      },
    );
    if (response.ok) {
      return await response.json();
    }
    throw new Error(`Request failed with status ${response.status}`);
  } catch (error) {
    console.log(error);
    throw new Error("Couldn't edit place");
  }
};
